import store from '@/store';
import { DASHBOARD_FEATURE } from '@/features';
import get from 'lodash/get';
import { cloneDeep } from 'lodash';

export const getRouteKey = route => [route.name, route.params && route.params.entity]
  .filter(Boolean)
  .join(':');

export const staffHomePageItems = [
  {
    name: 'dashboard',
    params: {},
  },
  {
    name: 'searcher',
    params: {
      entity: 'content',
    },
  },
  {
    name: 'searcher',
    params: {
      entity: 'category',
    },
  },
  {
    name: 'searcher',
    params: {
      entity: 'board',
    },
  },
].reduce((acc, route) => {
  acc[getRouteKey(route)] = route;
  return acc;
}, {});

export const isHomePageEnabled = () => store.getters.features[DASHBOARD_FEATURE];

/**
 * Returns the staff's preferred default site.
 * @return {string}
 */
export const getStaffDefaultSite = () => {
  if (!isHomePageEnabled()) {
    return store.getters.defaultSite.idAlias;
  }
  const homepage = store.getters['staff/homepage'];
  return get(homepage, 'params.site', store.getters.defaultSite.idAlias);
};

/**
 * Returns the staff's homepage.
 * @return {Route}
 */
export const getStaffHomepage = () => {
  if (!isHomePageEnabled()) {
    return null;
  }
  return cloneDeep(store.getters['staff/homepage']);
};
